import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { styles } from 'assets/scss/style-templates';
import { keyframes } from '@mui/system';

interface RotateIconLoadingProps {
  isLoading: boolean;
  onClick: () => void;
}

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RotateIconLoading = (props: RotateIconLoadingProps) => {
  const { isLoading, onClick } = props;
  return (
    <IconButton onClick={onClick}>
      <RefreshIcon
        sx={{
          color: isLoading
            ? styles.color.monotoneDarkLight
            : styles.color.darkShade,
          animation: isLoading
            ? `${rotateAnimation} 1s linear infinite`
            : 'none',
        }}
      />
    </IconButton>
  );
};

export default RotateIconLoading;
